import React, { useState } from 'react';
import { RiCloseLine } from 'react-icons/ri';
import { AiOutlineMenu } from "react-icons/ai";
import './Navbar.css';
import logo from '../../assets/logo.svg'

const Menu = () => (
  <ul className='links'>
    <li><a href="#home">Home</a></li>
    <li><a href="#about">What is GPT?</a></li>
    <li><a href="#possibility">Open AI</a></li>
    <li><a href="#features">Case Studies</a></li>
    <li><a href="#blogs">Library</a></li>
  </ul>
);

const Navbar = () => {

  const [ToggleMenu, setToggleMenu] = useState(false);

  return (
    <header className='navbar-header'>

      <nav className='navbar-container'>

        <div className='navbar-logo-container'>
          <img src={logo} alt="Logo" width={60} height={15} />
        </div>

        <div className='navbar-links-container'>
          <Menu />
        </div>

        <div className='navbar-buttons-container'>
          <button className='navbar-sign-in-btn'>Sign In</button>
          <button className='navbar-sign-up-btn'>Sign Up</button>
        </div>

        <div className='navbar-menu-icon'>
          {ToggleMenu
            ? <RiCloseLine color="#fff" size={30} onClick={() => setToggleMenu(false)} />
            : <AiOutlineMenu color="#fff" size={30} onClick={() => setToggleMenu(true)} />
          }
          {ToggleMenu && (
            <div className='navbar-menu scale-up-ver-top'>
              <Menu />
              <div className='menu-btn-container'>
              <button className='navbar-sign-in-btn'>Sign In</button>
              <button className='navbar-sign-up-btn'>Sign Up</button>
              </div>
            </div>
          )}
        </div>

      </nav>

    </header>
  )
}

export default Navbar
